export const getConfigPageState = state => state.configPage;
